export const projectDetailMixin = {
    /**
     * 这个混入是为了保存路由离开时的位置信息
     * @param to
     * @param from
     * @param next
     */
    beforeRouteLeave(to, from, next) {
        const scrollTop = this.$parent.$el.scrollTop;
        // 取出储存的位置
        const arrRouteType = from.path.split('/');
        const sRouteType = arrRouteType[arrRouteType.length - 1];
        this.$store.commit({type: 'projectDetailConstruction/SAVE_ROUTER_POSITION', val: scrollTop, routerType: sRouteType});

        next();
    },
}